(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vinplast-reel-mirror"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vinplast-mirror-controller')) {
    const initializeMirror = (root) => {
      if (root.dataset.mirrorReady) return;
      root.dataset.mirrorReady = 'true';
      const form = root.querySelector('form');
      const username = root.querySelector('[data-mirror-username]');
      const photo = root.querySelector('[data-mirror-photo]');
      const preview = root.querySelector('[data-mirror-preview]');
      const previewImage = root.querySelector('[data-mirror-preview-image]');
      const previewName = root.querySelector('[data-mirror-preview-name]');
      const error = root.querySelector('[data-mirror-error]');
      const messages = JSON.parse(root.querySelector('[data-mirror-messages]').textContent);
      let objectUrl = '';
      let generation = 0;
      const validateName = () => {
        username.setCustomValidity(username.validity.patternMismatch ? messages.usernameError : '');
        previewName.textContent = username.value ? '@' + username.value : messages.placeholder;
      };
      username.addEventListener('input', validateName);
      username.addEventListener('change', () => {
        username.value = username.value.trim().replace(/^@/, '');
        validateName();
      });
      photo.addEventListener('change', () => {
        const current = ++generation;
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        objectUrl = '';
        preview.hidden = true;
        error.textContent = '';
        photo.setCustomValidity('');
        const file = photo.files[0];
        if (!file) return;
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024 || !file.size) {
          photo.setCustomValidity(messages.fileError);
          error.textContent = messages.fileError;
          return;
        }
        objectUrl = URL.createObjectURL(file);
        photo.setCustomValidity(messages.imageError);
        previewImage.onload = () => {
          if (generation !== current) return;
          photo.setCustomValidity('');
          preview.hidden = false;
          validateName();
        };
        previewImage.onerror = () => {
          if (generation !== current) return;
          photo.setCustomValidity(messages.imageError);
          error.textContent = messages.imageError;
        };
        previewImage.src = objectUrl;
      });
      form.addEventListener('submit', (event) => {
        validateName();
        if (!form.reportValidity()) event.preventDefault();
      });
    };
    customElements.define('vinplast-mirror-controller', class extends HTMLElement {});
    document.querySelectorAll('[data-reel-mirror]').forEach(initializeMirror);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-reel-mirror]').forEach(initializeMirror);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
